import API_URLS from '@Constants/apiUrls.constants';
import { CommonConstants } from '@Constants/index';
import { GetLists } from '@Models/common.models';
import {
  EmailsMutationResponse,
  EmailResponse,
  EmailsListResponse,
  EmailAdd,
  EmailEdit,
  ArchiveEmails,
  DeleteEmails,
} from '@Models/emails.models';
import query from '@Utils/common/query.utils';

import { baseApi } from './baseApi.service';

export const emailsApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Emails', 'Email'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      /** Fetch emails list with given queries */
      getEmailsLists: builder.query<EmailsListResponse, GetLists>({
        query: ({ data: { direction, ...resData }, isArchive = false }) =>
          `${API_URLS.EMAILS}${isArchive ? '?archive&' : '?'}${
            direction || CommonConstants.INITIAL_SORT_DIRECTION
          }&${query.stringify({
            ...resData,
          })}`,
        providesTags: ['Emails'],
      }),
      /** Fetch email with given id */
      getEmail: builder.query<EmailResponse, string>({
        query: (id) => `${API_URLS.EMAILS}/${id}`,
        providesTags: ['Email'],
      }),
      /** Archive the Emails with the given ids */
      archiveEmails: builder.mutation<EmailsMutationResponse, ArchiveEmails>({
        query: (body) => ({
          url: `${API_URLS.EMAILS}/archive`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Emails'],
      }),
      /** Delete the email with the given id */
      deleteEmails: builder.mutation<EmailsMutationResponse, DeleteEmails>({
        query: (body) => ({
          url: `${API_URLS.EMAILS}/delete`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Emails'],
      }),
      /** Add new email */
      addEmail: builder.mutation<EmailResponse, EmailAdd>({
        query: (body) => ({
          url: `${API_URLS.EMAILS}`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Email', 'Emails'],
      }),
      addEmailsFromGroup: builder.mutation<
        void,
        { globalEmailsIds: string[]; userId: string | number | null }
      >({
        query: (body) => ({
          url: `${API_URLS.EMAILS}/group`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Emails'],
      }),
      /** Edit the email with the given id */
      editEmail: builder.mutation<EmailResponse, EmailEdit>({
        query: (body) => ({
          url: `${API_URLS.EMAILS}/${body.id}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['Email', 'Emails'],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetEmailsListsQuery,
  useGetEmailQuery,
  useArchiveEmailsMutation,
  useDeleteEmailsMutation,
  useAddEmailMutation,
  useAddEmailsFromGroupMutation,
  useEditEmailMutation,
} = emailsApi;
